export const messages = {
  en: {
    addReserveDining: {
      title: 'Add Dining Product',
      goodsName: 'Name',
      goodsNamePlaceholder: 'Required, please enter name',
      paramsId: 'Parameter',
      paramsIdPlaceholder: 'Required, please select parameter',
      price: 'Price',
      pricePlaceholder: 'Required, please enter price',
      sort: 'Sort',
      sortPlaceholder: 'Required, please enter sort',
      startDate: 'Start Date',
      startDatePlaceholder: 'Required, please select start date',
      endDate: 'End Date',
      endDatePlaceholder: 'Required, please select end date',
      imgUrl: 'Product Cover',
      state: 'Status',
      statePlaceholder: 'Required, please select status',
      stateOff: 'Off Shelf',
      stateOn: 'On Shelf',
      goodsDesc: 'Product Description',
      goodsDescPlaceholder: 'Required, please enter product description',
      content: 'Product Details',
      contentPlaceholder: 'Required, please enter product details'
    },
    uploadImage: {
      fileSizeLimit: 'Image size cannot exceed 2MB',
      uploadFailed: 'Image upload failed'
    }
  },
  zh: {
    addReserveDining: {
      title: '添加就餐商品',
      goodsName: '名称',
      goodsNamePlaceholder: '必填，请填写名称',
      paramsId: '参数',
      paramsIdPlaceholder: '必填，请选择参数',
      price: '单价',
      pricePlaceholder: '必填，请填写单价',
      sort: '排序',
      sortPlaceholder: '必填，请填写排序',
      startDate: '开始时间',
      startDatePlaceholder: '必填，请填写开始时间',
      endDate: '结束时间',
      endDatePlaceholder: '必填，请填写结束时间',
      imgUrl: '产品封面',
      state: '状态',
      statePlaceholder: '必填，请选择状态',
      stateOff: '未上架',
      stateOn: '上架',
      goodsDesc: '商品简介',
      goodsDescPlaceholder: '必填，请填写商品简介',
      content: '商品详情',
      contentPlaceholder: '必填，请输入商品描述'
    },
    uploadImage: {
      fileSizeLimit: '图片大小不能超过2MB',
uploadFailed: '圖片上傳失敗'
    }
  },
  'zh-TW': {
    addReserveDining: {
      title: '添加就餐商品',
      goodsName: '名稱',
      goodsNamePlaceholder: '必填，請填寫名稱',
      paramsId: '參數',
      paramsIdPlaceholder: '必填，請選擇參數',
      price: '單價',
      pricePlaceholder: '必填，請填寫單價',
      sort: '排序',
      sortPlaceholder: '必填，請填寫排序',
      startDate: '開始時間',
      startDatePlaceholder: '必填，請填寫開始時間',
      endDate: '結束時間',
      endDatePlaceholder: '必填，請填寫結束時間',
      imgUrl: '產品封面',
      state: '狀態',
      statePlaceholder: '必填，請選擇狀態',
      stateOff: '未上架',
      stateOn: '上架',
      goodsDesc: '商品簡介',
      goodsDescPlaceholder: '必填，請填寫商品簡介',
      content: '商品詳情',
      contentPlaceholder: '必填，請輸入商品描述'
    },
    uploadImage: {
      fileSizeLimit: '圖片大小不能超過2MB',
      uploadFailed: '圖片上傳失敗'
    }
  }
}